import React from 'react';
import { AppRecommendationsContext } from '../index';
const useAppRecommendationsProvider = () => {
  const {
    onEvents,
    contextResolver,
    endpoint
  } = React.useContext(AppRecommendationsContext);
  return {
    onEvents,
    contextResolver,
    endpoint
  };
};
export default useAppRecommendationsProvider;